module.exports = __webpack_public_path__ + "img/bb.68cbe434.svg";